module.exports = __webpack_public_path__ + "img/icon-data-light-blue.959c7bf0.svg";